import '../styles/main.scss';

import React from 'react';

import Header from '../components/Header';
import Footer from '../components/Footer';
import Cart from '../components/Cart';

import Analytics from '../components/Analytics';
import NewsletterModal from '../components/NewsletterModal';
import { CartProvider, ShopifyProvider } from '@shopify/hydrogen-react';

import {
  LazyMotion,
  domAnimation,
  m as motion,
  AnimatePresence,
} from 'framer-motion';

export const TRANSITION_DURATION = 400;

const Layout = ({ pageContext, children, location }) => {
  const { header, footer } = pageContext;

  const resetScroll = () => {
    window.scrollTo(0, 0);
  };

  return (
    <ShopifyProvider
      languageIsoCode="EN"
      countryIsoCode="US"
      storeDomain="eugenie-detroit.myshopify.com"
      storefrontToken="3dd3b575a19c0db884f6913fbfe96612"
      storefrontApiVersion="2025-01"
    >
      <CartProvider>
        <LazyMotion features={domAnimation} strict>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: TRANSITION_DURATION / 1000 }}
          >
            <Header location={location} {...header} />
            <Analytics
              // facebookPixelId={process.env.GATSBY_FB_PIXEL_ID}
              klaviyoId={process.env.GATSBY_KLAVIYO_COMPANY_ID}
            />
            <Cart />
            <NewsletterModal
              klaviyoListId={process.env.GATSBY_KLAVIYO_LIST_ID}
            />
            <AnimatePresence mode="wait" onExitComplete={resetScroll}>
              <motion.div
                key={
                  location.pathname.includes('account')
                    ? location.pathname.split('account')[0]
                    : location.pathname
                }
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: TRANSITION_DURATION / 1000 }}
                className="bg-warm z-2"
              >
                {children}
              </motion.div>
            </AnimatePresence>
            <Footer {...footer} />
          </motion.div>
        </LazyMotion>
      </CartProvider>
    </ShopifyProvider>
  );
};

export default Layout;
